import url from "@websanova/url/dist/es5-url-tld.min"
import {URL_OSS_CHAT_PREFIX} from "@/constants/rpc";

export function getUrlFileExt(fileUrl) {
    return url("fileext", fileUrl)
}

export function getUrlFileName(fileUrl) {
    return url("file", fileUrl)
}

export function getUrlFilePath(fileUrl) {
    return url("path", fileUrl)
}

export function getUrlHost(fileUrl) {
    return url("host", fileUrl)
}

export function getUrlSchema(fileUrl) {
    return url("protocol", fileUrl)
}

export function getUrlPort(fileUrl) {
    return url("port", fileUrl)
}

export function getUrlQuery(fileUrl) {
    return url("query", fileUrl)
}

export function isUrl(fileUrl) {
    // const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    // return urlregex.test(fileUrl)

    // let elm = document.createElement('input');
    // elm.setAttribute('type', 'url');
    // elm.value = fileUrl;
    // return elm.validity.valid;

    try {
        new URL(fileUrl);
        return true;
    } catch (_) {
        return false;
    }
}

export function isOssUrl(fileUrl) {
    fileUrl = fileUrl || ""
    fileUrl = fileUrl.toLowerCase()
    return fileUrl?.indexOf(URL_OSS_PREFIX) == 0
}

export function isOssChatUrl(fileUrl) {
    fileUrl = fileUrl || ""
    fileUrl = fileUrl.toLowerCase()
    return fileUrl?.indexOf(URL_OSS_CHAT_PREFIX) == 0
}
